export default __webpack_public_path__ + "static/media/awork_logo.58d895e7.svg";